import React, { PureComponent } from "react";
import { connectStore } from "redux-box";
import { module as pronunciationLexicon } from "@st/pronunciationLexicon";
import {
  MainBodyContainer,
  PlusButton,
  PlusIcon,
} from "static/styled/custom.styled";
import PronunciationHeader from "./pronunciation-header/PronunciationHeader";
import PronunciationList from "./pronunciation-list/PronunciationList";
import PronunciationModal from "./pronunciation-modal/PronunciationModal";

class PronunciationView extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { showModal: false };
  }

  componentDidMount() {
    this.props.pronunciationLexicon.requestList();
    this.props.pronunciationLexicon.requestVoices();
  }

  openModal = (entry = null) => {
    this.props.pronunciationLexicon.setSelected(entry);
    this.setState({ showModal: true });
  };

  closeModal = () => {
    this.props.pronunciationLexicon.setSelected(null);
    this.setState({ showModal: false });
  };

  handleAddClick = () => {
    this.openModal(null);
  };

  render() {
    const { showModal } = this.state;
    return (
      <MainBodyContainer>
        <PronunciationHeader />
        <PronunciationList onEdit={this.openModal} />

        <PlusButton hide={showModal} onClick={this.handleAddClick}>
          <PlusIcon
            primary
            alt="Plus Icon"
            src={require("static/img/plusicon.png")}
          />
        </PlusButton>

        {showModal && <PronunciationModal onClose={this.closeModal} />}
      </MainBodyContainer>
    );
  }
}

export default connectStore({ pronunciationLexicon })(PronunciationView);
